import React from 'react';
import styled from 'styled-components';

const WishlistSideContentWrapper = styled.div(
  ({ theme: { media, space } }) => ({
    width: '100%',
    [media.tablet]: {
      width: `${(2 / 3) * 100}%`,
      paddingLeft: space[3],
    },
  })
);

export const WishlistSideContent: React.FC<{
  children?: React.ReactNode;
}> = props => {
  const { children } = props;

  return <WishlistSideContentWrapper>{children}</WishlistSideContentWrapper>;
};
